<template>
  <div class="mt-10">
    <b-row align-h="center">
       <b-col cols="12" v-if="typeof selectedVehicle._id !== 'undefined'">
          <b-form-group label="Select facilities:">
            <facilities
              v-model="selectedVehicle.facilitiesList"
              :facilities="facilities"
              :selected="selectedVehicle.facilitiesList"
              :style="{'width': '275px'}"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" align="right">
          <b-button size="sm" variant="primary" @click="updateVehicle" :disabled="updating">
            Update Vehicle
            <b-spinner small v-if="updating"></b-spinner>
          </b-button> 
          <b-button class="ml-10" size="sm" variant="secondary" @click="closeModal">Close</b-button>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import facilities from "@/components/facilities";

export default {
  name: "vehicleFacilities",
  components: {
    facilities
  },
  props: {
    selectedVehicle: Object,
    driverId:String,
  },
  computed: {
  },
  data() {
    return {
      facilities: [],
      updating: false,
    };
  },
  watch: {},
  async created() {
      await this.getFacilities();
  },
  methods: {
    async getFacilities() {
      this.facilities = await shebahApi.api.drivers.vehicles.vehicleFacilities(this.driverId,this.selectedVehicle._id);
    },
    closeModal(){
      this.$emit("closeCallback",{});
    },
    async updateVehicle() {
      try {
        this.updating = true;
        let savedVehicle=await shebahApi.api.drivers.vehicles.saveVehicle(
          this.driverId,
          this.selectedVehicle,
          this.selectedVehicle._id
        );
        this.updating = false;
      } catch (e) {
        this.updating = false;
        console.error(e);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>